module.exports = __webpack_public_path__ + "media/images/mock-thumbs/article-2-099f5c5b0dc78008dfec343afe8cb83f.png";